import { ProductPage } from "./ProductPage";
import { buildTv6UltraConfig } from "./configs/tv6-ultra";

export function Tv6UltraPage() {
  return <ProductPage build={buildTv6UltraConfig} />;
}
